import React, { useEffect, useState } from 'react';
import { makeStyles, TextField } from '@material-ui/core';
import SelectionSwitch from '../../../components/UI/SelectionSwitch';
import { Fragment } from 'react';
import CustomDatePicker from '../../../components/UI/CustomDatePicker';
import AreaSelect from '../../../components/AreaSelect';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  formControl: {
    minWidth: 130,
  },
  topSeparation: {
    marginTop: 10,
  },
  rigthSeparation: {
    marginRight: 10,
  },
  rowDirection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& > *:not(:last-child)': {
      marginRight: '2em',
    },
  },
}));

const Closure = ({ reply, setReply }) => {
  const classes = useStyles();

  return (
    <Fragment>
      <TextField
        className={classes.topSeparation}
        margin="dense"
        id="reply"
        multiline
        rows={4}
        variant="outlined"
        label="Respuesta"
        onChange={e => setReply(e.target.value)}
        value={reply}
      />
      <CustomDatePicker readOnly margin="dense" value={new Date()} label="Fecha de cierre" style={{ width: 150 }} />
    </Fragment>
  );
};

const Derivation = ({ observation, setObservation, area, setArea }) => {
  const classes = useStyles();

  return (
    <Fragment>
      <TextField
        className={classes.topSeparation}
        margin="dense"
        id="areaObservation"
        multiline
        rows={4}
        variant="outlined"
        label="Observación del área"
        onChange={e => setObservation(e.target.value)}
        value={observation}
      />
      <AreaSelect disableOptionAll style={{ marginBottom: 8 }} value={area} setValue={setArea} title="Área a derivar" />
    </Fragment>
  );
};

const ClaimNewDerivation = ({ setNewDerivation }) => {
  const classes = useStyles();

  const [reply, setReply] = useState('');
  const [observation, setObservation] = useState('');
  const [area, setArea] = useState('');
  const [isClosure, setIsClosure] = useState(false);

  useEffect(() => {
    if (isClosure) {
      setNewDerivation({
        reply: reply,
        state: false,
      });
    } else {
      setNewDerivation({
        state: true,
        idArea: area,
        observation: observation,
      });
    }
  }, [isClosure, reply, observation, area]);

  return (
    <div className={classes.root}>
      <SelectionSwitch leftLabel="Derivación" rightLabel="Cierre" value={isClosure} setValue={setIsClosure} />
      {isClosure ? (
        <Closure reply={reply} setReply={setReply} />
      ) : (
        <Derivation observation={observation} setObservation={setObservation} area={area} setArea={setArea} />
      )}
    </div>
  );
};

export default ClaimNewDerivation;
